import { render, staticRenderFns } from "./AccountMigratorPage.vue?vue&type=template&id=7b13f471&"
import script from "./AccountMigratorPage.vue?vue&type=script&lang=js&"
export * from "./AccountMigratorPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountMigratorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports